export const subGroupOptions = [
  "Alternating Current (< 1 GHz)",
  "Direct Current",
  "Electrical Equipment",
  "Temperature Simulation",
  "Time & Frequency",
  "EMI/ EMC",
  "RF/Microwave (1 GHz and Above)",
  "Miscellaneous"
];